import zh from './zh'
import en from './en'

/**
 * 按语言取文案（中英文两套页面共用组件）。
 */
export function getCopy(lang) {
  return lang === 'en' ? en : zh
}

/**
 * 中英文路径互转，保留 query / hash。
 * 例：/ ↔ /en ，/transport?type=water ↔ /en/transport?type=water
 */
export function switchLangPath(fullPath, targetLang) {
  const raw = fullPath || '/'
  let path = raw
  let suffix = ''
  const hashIdx = raw.indexOf('#')
  if (hashIdx >= 0) {
    suffix = raw.slice(hashIdx)
    path = raw.slice(0, hashIdx)
  }
  const queryIdx = path.indexOf('?')
  if (queryIdx >= 0) {
    suffix = path.slice(queryIdx) + suffix
    path = path.slice(0, queryIdx)
  }
  if (!path) {
    path = '/'
  }
  let next = path
  if (targetLang === 'en') {
    if (path === '/' || path === '') {
      next = '/en'
    } else if (path.indexOf('/en') === 0) {
      next = path
    } else {
      next = '/en' + path
    }
  } else if (path === '/en' || path === '/en/') {
    next = '/'
  } else if (path.indexOf('/en/') === 0) {
    next = path.slice(3) || '/'
  }
  return next + suffix
}

/**
 * 带语言前缀的菜单 path。
 */
export function langPath(lang, path) {
  if (lang === 'en') {
    if (!path || path === '/') {
      return '/en'
    }
    return '/en' + path
  }
  return path || '/'
}
